<!--
<section class="mission-area ptb-100">
    <div class="container">
        <div class="mission-content">
            <div class="section-title text-start">
                <h2>Centrul Medical de diagnostic, tratament ambulatoriu si medicina preventiva Bucuresti </h2>
            </div>
            <div class="mission-slides">
                <owl-carousel-o [options]="missionSlides" (change)="getData($event)">
                    <ng-template carouselSlide>
                        <h3>Activitate/Serviciu promovat #1</h3>
                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut nisi ut aliquip ex ea commodo consequat.</p>
                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut nisi ut aliquip ex ea commodo consequat.</p>
                        <a routerLink="/" class="default-btn"><i class='bx bx-book-reader icon-arrow before'></i><span class="label">Detalii</span><i class="bx bx-book-reader icon-arrow after"></i></a>
                    </ng-template>
                    <ng-template carouselSlide>
                        <h3>Activitate/Serviciu promovat #2</h3>
                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut nisi ut aliquip ex ea commodo consequat.</p>
                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut nisi ut aliquip ex ea commodo consequat.</p>
                        <a routerLink="/" class="default-btn"><i class='bx bx-book-reader icon-arrow before'></i><span class="label">Detalii</span><i class="bx bx-book-reader icon-arrow after"></i></a>
                    </ng-template>
                </owl-carousel-o>
            </div>
        </div>
    </div>
</section>
-->

<ngx-slick-carousel class="carousel" [config]="slideConfig">
    <div ngxSlickItem class="full mission-area pediatrie">
        <div class="container">

            <div class="mission-content">
                <h2>Centrul Medical de diagnostic, tratament ambulatoriu și medicină preventivă București </h2>
                <h3>Pediatrie</h3>
                <p>Secția de Pediatrie din cadrul CMDTAMP dispune de o echipăformată din medici primari, specialiști,
                    pediatri și de familie, medic neuropsihiatru, psiholog-logoped, asistente și registratoare medicale.
                    Oferim servicii medicale complete(inclusiv vaccin) pentru copiii cu vârste între 0-18 ani.</p>
                <a routerLink="/specialitati-medicale/pediatrie" class="default-btn"><i class='bx bx-book-reader icon-arrow before'></i><span
                        class="label">Detalii</span><i class="bx bx-book-reader icon-arrow after"></i></a>
            </div>

        </div>
    </div>
    <div ngxSlickItem class="full mission-area dializa">
        <div class="container">
            <div class="mission-content">
                <h2>Centrul Medical de diagnostic, tratament ambulatoriu si medicina preventiva Bucuresti </h2>
                <h3>Centrul de dializă</h3>
                <p>Secția de Dializă din cadrul CMDTAMP asigură tratament de substituțierenalăpacienților cu
                    insuficiențărenalăcronică din anul 2001. Cu peste 20 de ani de experiență în oferirea serviciilor și
                    tratamentul de dializă, centrul nostru a obținut 2 diplome de excelență în anii 2011 și 2016.</p>
                <a routerLink="/specialitati-medicale/nefrologie" class="default-btn"><i class='bx bx-book-reader icon-arrow before'></i><span
                        class="label">Detalii</span><i class="bx bx-book-reader icon-arrow after"></i></a>
            </div>

        </div>
    </div>
    <!-- <div ngxSlickItem class="full mission-area chirurgie-plastica">
        <div class="container">
            <div class="mission-content">
                <h2>Centrul Medical de diagnostic, tratament ambulatoriu si medicina preventiva Bucuresti </h2>
                <h3>Chirurgie Plastică</h3>
                <p>sed do eiusmod tempor incididunt, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut
                    labore et dolore magna aliqua. Ut nisi ut aliquip ex ea commodo consequat.</p>
                <p>adipisicing elit, sed do eiusmod tempor incididunt , Lorem ipsum dolor sit amet, co sed do eiusmod
                    tempor incididunt ut labore et dolore magna aliqua. Ut nisi ut aliquip ex ea commodo consequat.</p>
                <a routerLink="/" class="default-btn"><i class='bx bx-book-reader icon-arrow before'></i><span
                        class="label">Detalii</span><i class="bx bx-book-reader icon-arrow after"></i></a>
            </div>

        </div>
    </div> -->
    <div ngxSlickItem class="full mission-area vaccin">
        <div class="container">
            <div class="mission-content">
                <h2>Centrul Medical de diagnostic, tratament ambulatoriu si medicina preventiva Bucuresti </h2>
                <h3>Vaccin</h3>
                <p>Începând cu martie 2021, în cadrul CMDTAMP se efectuează vaccinarea împotriva noului coronavirus, cu
                    vaccinurile Pfizer, respectiv Moderna. Pentru mai multe detalii despre Coronavirus, accesați
                    platforma #ROVACCINARE.</p>
                <a href="https://vaccinare-covid.gov.ro/" target="_blank" class="default-btn"><i class='bx bx-book-reader icon-arrow before'></i><span
                        class="label">Detalii</span><i class="bx bx-book-reader icon-arrow after"></i></a>
            </div>

        </div>
    </div>
</ngx-slick-carousel>
